<template>
    <div>
        <header-nav :cur="4" />
        <!-- 搜索 -->
        <div class="nav" v-if="!off">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>&nbsp;考试&nbsp;>
                    <span @click="back()">考试详情&nbsp;></span>
                    <span class="infor" v-if="idItem == 0">日常练习</span>
                    <span class="infor" v-if="idItem == 1">错题练习</span>
                    <span class="infor" v-if="idItem == 2">模拟考试</span>
                </span>
            </div>
        </div>
        <!-- 正式考试头部考生信息 -->
        <div class="head" v-if="off">
            <div class="navtab headbox">
                <!-- <div class="box"> -->
                <img src="../../assets/img/index/course.jpg" alt="" />
                <ul>
                    <li>姓名：易烊千玺</li>
                    <li>准考证号：59875354</li>
                    <li>身份证号：142563269987546985</li>
                    <li>报考科目：一级建造师</li>
                    <li>满分：100分</li>
                    <li>及格线：80分</li>
                    <li>考试时间：2022年-2月-25日</li>
                    <li>考试时长：120分钟</li>
                </ul>
                <!-- </div> -->

                <div class="time">
                    考试倒计时
                    <div>
                        {{ keepTime }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 练习 -->
        <div class="navtab exercise">
            <div class="box-fixed" v-show="isFixed"></div>
            <div class="leftbox" :class="{ 'is-fixed': isFixed }">
                <!-- exercise为练习,当进入练习界面的时候 -->
                <div class="title" v-if="exercise">道路交通工程</div>
                <!-- simulation为模拟考试,当进入模拟考试界面的时候 -->
                <div class="simulation" v-if="simulation && !off">
                    <div class="count">
                        倒计时
                        <div>{{ keepTime }}</div>
                    </div>
                    <div class="our">
                        个人信息
                        <div class="session">
                            <div>考生姓名：张三</div>
                            <div>考试科目：一级建造师</div>
                            <div>考试时长：60分钟</div>
                            <div>考试总分：100分</div>
                        </div>
                    </div>
                </div>
                <div class="write">答题卡</div>
                <ul>
                    <li v-for="(item, index) in indexList" :class="{ activeli: item.check }" :key="index" @click="scrollTo(index)" :name="'position-' + index">
                        {{ item.id }}
                    </li>
                </ul>
            </div>
            <div class="answer">
                <div class="title">
                    选择题
                    <span>（30分）</span>
                </div>
                <div>
                    <div class="timubox" v-for="(item, indx) in option" :key="item.id" :id="'position-' + item.id">
                        <div class="timu">
                            {{ item.title }}
                        </div>
                        <div
                            class="list"
                            v-for="(selitem, i) in item.selectItem"
                            :key="selitem.id"
                            @click="selectAnswer(indx, i, item.id)"
                            :class="{ listactive: selitem.checkOpt }"
                        >
                            <span :class="{ spanactive: selitem.checkOpt }">{{ selitem.opt }}</span>
                            {{ selitem.cont }}
                        </div>
                        <!-- 答案 -->
                        <div class="answer" v-show="show" v-if="!off">
                            <div class="top">正确答案：{{ item.option }}</div>
                            <div class="bottom">
                                <span>答案解析：</span>
                                {{ item.answer }}
                            </div>
                        </div>
                    </div>
                    <div class="timubox" v-for="(item, indx) in option1" :key="indx" :id="'position-' + item.id">
                        <div class="timu">
                            {{ item.title }}
                        </div>
                        <div
                            class="list"
                            v-for="(selitem, i) in item.selectItem"
                            :key="selitem.id"
                            @click="selectAnswerMore(indx, i, item.id)"
                            :class="{ listactive: selitem.checkOpt }"
                        >
                            <span :class="{ spanactive: selitem.checkOpt }">{{ selitem.opt }}</span>
                            {{ selitem.cont }}
                        </div>
                        <!-- 答案 -->
                        <div class="answer" v-show="show" v-if="!off">
                            <div class="top">正确答案：{{ item.option }}</div>
                            <div class="bottom">
                                <span>答案解析：</span>
                                {{ item.answer }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title">
                    问答题
                    <span>（30分）</span>
                </div>
                <div>
                    <div class="quest" id="position--3">
                        3.
                        操作系统是计算机的一种系统软件，它有效地管理和控制计算机的（软、硬件资源），合理组织计算机的工作流程，以使整个计算机系统高效地运行操作系统是计算机的一种系统软件，它有效地管理和控制计。
                        <textarea name="" id="" cols="30" rows="10" placeholder="请输入您的答案"></textarea>
                    </div>
                    <div class="quest">
                        4.
                        操作系统是计算机的一种系统软件，它有效地管理和控制计算机的（软、硬件资源），合理组织计算机的工作流程，以使整个计算机系统高效地运行操作系统是计算机的一种系统软件，它有效地管理和控制计。
                        <textarea name="" id="" cols="30" rows="10" placeholder="请输入您的答案"></textarea>
                        <!-- 答案 -->
                        <div class="answerlist" v-show="show" v-if="!off">
                            <div class="bottom">
                                <span>答案解析：</span>
                                线粒体的分裂都涉及到线粒体的一分为二，因此都依赖于膜的流动性，A项正确；洋葱的分生区细胞不断分裂，比表皮细胞需要能量多，正常线粒体分裂更为活跃，
                            </div>
                            <div class="bottom">
                                <span>答案解析：</span>
                                线粒体的分裂都涉及到线粒体的一分为二，因此都依赖于膜的流动性，A项正确；洋葱的分生区细胞不断分裂，比表皮细胞需要能量多，正常线粒体分裂更为活跃，
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit" @click="submit(idItem)">
                    <img src="../../assets/img/exam/exam.svg" alt="" />
                    我要交卷
                </div>
            </div>
        </div>
        <footer-nav />
    </div>
</template>
<script>
import Vue from 'vue';
import { IndexBar, IndexAnchor, Toast } from 'vant';

Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Toast);
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
            idItem: '',
            off: false,
            // 考试倒计时start
            keepTime: '倒计时开始',
            limittime: 120,
            settime: '',
            flag: false,
            // 考试倒计时end
            // 是否考试题 固定定位
            isFixed: false,
            // 当进入练习页面时
            exercise: false,
            // 当进入模拟考试的时候
            simulation: false,
            show: false,
            indexList: [
                { id: 1, check: false },
                { id: 2, check: false },
            ],
            option: [
                {
                    id: 1,
                    title: '  1.(单选题) 操作系统是计算机的一种系统软件，它有效地管理和控制计算机的（软、硬件资源），合理组织计算机的工作流程，以使整个计算机系统高效地运行操作系统是计算机的一种系统软件，它有效地管理和控制计',
                    selectItem: [
                        { opt: 'A', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'B', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'C', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'D', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                    ],

                    option: 'D',
                    answer: '线粒体的分裂都涉及到线粒体的一分为二，因此都依赖于膜的流动性，A项正确；洋葱的分生区细胞不断分裂，比表皮细胞需要能量多，正常线粒体分裂更为活跃，',
                },
            ],

            option1: [
                {
                    id: 2,
                    title: '  2.(单选题) 操作系统是计算机的一种系统软件，它有效地管理和控制计算机的（软、硬件资源），合理组织计算机的工作流程，以使整个计算机系统高效地运行操作系统是计算机的一种系统软件，它有效地管理和控制计',
                    selectItem: [
                        { opt: 'A', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'B', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'C', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                        { opt: 'D', cont: '并发和（共享）是操作系统的两个基本特征，两者互为依存条件', checkOpt: false },
                    ],

                    option: 'D',
                    answer: '线粒体的分裂都涉及到线粒体的一分为二，因此都依赖于膜的流动性，A项正确；洋葱的分生区细胞不断分裂，比表皮细胞需要能量多，正常线粒体分裂更为活跃，',
                },
            ],
			id:''
        };
    },
    mounted() {
        this.idItem = this.$route.query.id;
        if (this.idItem == 0) {
            this.exercise = true;
            this.off = false;
            this.simulation = false;
            console.log(this.exercise, this.off);
        }
        if (this.idItem == 2) {
            this.exercise = false;
            this.off = false;
            this.simulation = true;
        }
        if (this.idItem == 3) {
            this.$router.push('/exam/notice');
        }
        this.off = this.$route.query.off;
        if (this.idItem == 2 || this.idItem == 3) {
            this.StartCountDown();
        }

        window.addEventListener('scroll', this.handleScroll);
    },
	created() {
		this.id = this.$route.query.wid;
		alert(this.id);
	},
    methods: {
        // 监听滚动条位置
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.isFixed = scrollTop > 170 ? true : false;
        },
        // 返回按钮
        back() {
            this.$router.back(-1);
        },
        // 考试倒计时start
        StartCountDown() {
            var mydate = new Date();
            console.log(mydate);
            console.log(mydate.getMinutes());
            mydate.setMinutes(mydate.getMinutes() + this.limittime);
            this.settime = mydate;
            console.log(this.settime);

            let time = setInterval(() => {
                if (this.flag == true) {
                    clearInterval(time);
                }
                this.timeDown();
            }, 1000);
        },
        timeDown() {
            const endTime = new Date(this.settime);
            const nowTime = new Date();
            let leftTime = (endTime.getTime() - nowTime.getTime()) / 1000;
            // console.log(leftTime);

            // let d = parseInt(leftTime / (24 * 60 * 60));
            let hourTime = leftTime % (24 * 60 * 60);
            let h = this.formate(parseInt(hourTime / (60 * 60)));
            let minTime = leftTime % (60 * 60);
            let m = this.formate(parseInt(minTime / 60));
            let s = this.formate(parseInt(minTime % 60));
            if (leftTime <= 0) {
                this.flag = true;
                alert('时间到，停止作答');
            }
            this.keepTime = `${h}:${m}:${s}`;
            // console.log(this.keepTime);
        },
        formate(time) {
            if (time >= 10) {
                return time;
            } else {
                return `0${time}`;
            }
        },
        // 考试倒计时end

        submit(idItem) {
            if (idItem == 0 || idItem == 1) {
                this.show = true;
            } else {
                Toast('提交成功');
                this.$router.push('/exam/detail');
            }
        },
        /*
            点击选择单选选项
            @parme curId:当前题的Id
        */
        selectAnswer(i, j, curId) {
            // 判断四个选项有没有为true
            for (let n = 0; n < 4; n++) {
                if (n != j) {
                    this.option[i].selectItem[n].checkOpt = false;
                }
            }
            // 判断点击的状态如果是false 则未true
            if (!this.option[i].selectItem[j].checkOpt) {
                this.option[i].selectItem[j].checkOpt = true;
            } else {
                for (let n = 0; n < 4; n++) {
                    this.option[i].selectItem[n].checkOpt = false;
                }
            }
            for (let n = 0; n < this.indexList.length; n++) {
                if (this.indexList[n].id == curId) {
                    if (this.option[i].selectItem[j].checkOpt) {
                        this.indexList[n].check = true;
                    } else {
                        this.indexList[n].check = false;
                    }
                }
            }
        },
        /*
            点击选择多选选项
            @parme curId:当前题的Id
        */
        selectAnswerMore(i, j, curId) {
            this.option1[i].selectItem[j].checkOpt = !this.option1[i].selectItem[j].checkOpt;
            let count = 0;
            let currListIndex;
            for (let m = 0; m < 4; m++) {
                for (let n = 0; n < this.indexList.length; n++) {
                    if (this.indexList[n].id == curId) {
                        currListIndex = n;
                        if (this.option1[i].selectItem[m].checkOpt) {
                            count++;
                        }
                    }
                }
            }
            if (count > 0) {
                this.indexList[currListIndex].check = true;
            } else {
                this.indexList[currListIndex].check = false;
            }
        },
        // 点击左侧跳转到右侧对ele应位置
        scrollTo(index) {
            // document.getElementById('position-' + (index + 1)).scrollTop();
            console.log(document.getElementById('position-' + (index + 1)));
            let ele = document.getElementById('position-' + (index + 1));
            console.log(ele.scrollTop);
            window.scrollTo(0, ele.offsetTop - 80);
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        // height: 177px;
        .top {
            display: block;
            font-size: 16px;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
    }
    // 正式考试头部考生信息
    .head {
        width: 100%;
        // height: 219px;
        background: #f7f8fa;
        border-radius: 5px 5px 5px 5px;
        .headbox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 30px 0;
    
            img {
                // flex: 1;
                width: 120px;
                height: 161px;
                margin-right: 19px;
            }
            ul {
                margin-left: -251px;
                // flex: 7;
                display: flex;
                width: 50%;
                flex-wrap: wrap;
                justify-content: space-between;
                li {
                    width: 50%;
                    font-size: 16px;
                    color: #000000;
                    line-height: 40px;
                }
            }
            .time {
                // flex: 1;
                float: right;
                font-size: 22px;
                font-weight: 600;
                color: #333333;
                text-align: center;
                div {
                    width: 234px;
                    height: 59px;
                    line-height: 59px;
                    text-align: center;
                    background: #2961EF;
                    border-radius: 5px 5px 5px 5px;
                    font-size: 36px;
                    font-weight: normal;
                    color: #ffffff;
                    margin-top: 12px;
                }
            }
        }
    }
    // 练习
    .exercise {
        margin-top: 34px;
        // position: fixed;
        // display: flex;
        .leftbox {
            display: inline-block;
            vertical-align: top;
            margin-right: 42px;
            width: 267px;
            background: #f7f8fa;
            // 练习界面样式
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                height: 65px;
                padding-left: 14px;
                line-height: 65px;
                border-bottom: 1px dashed #8c97b0;
            }
            // 模拟考试界面样式
            .simulation {
                padding: 11px 16px;
                .count {
                    font-size: 18px;
                    color: #333333;
                    div {
                        height: 59px;
                        line-height: 59px;
                        text-align: center;
                        background: #ebf5ff;
                        border-radius: 5px 5px 5px 5px;
                        opacity: 1;
                        border: 1px solid #c2e0fe;
                        font-size: 36px;
                        color: #2961EF;
                        margin: 13px 0 26px;
                    }
                }
                .our {
                    font-size: 18px;
                    color: #333333;
                    .session {
                        margin-top: 16px;
                        background: #ffffff;
                        padding: 16px 13px;
                        div {
                            font-size: 16px;
                            color: #666666;
                            line-height: 30px;
                        }
                    }
                }
            }
            .write {
                font-size: 18px;
                color: #555555;
                padding-left: 14px;
                margin: 17px 0;
            }
            ul {
                display: flex;
                flex-wrap: wrap;
                padding: 0 16px;
                padding-bottom: 20px;
                li {
                    width: 17%;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    background: #ffffff;
                    border: 1px solid #dddddd;
                    font-size: 16px;
                    color: #999999;
                    margin-right: 2.5%;
                    margin-bottom: 13px;
                    &:nth-child(5n) {
                        margin-right: 0;
                    }
                }
                .activeli {
                    background: #2961EF;
                    color: #ffffff;
                    border: 1px solid #2961EF;
                }
            }
        }
        .is-fixed {
            position: fixed;
            top: 0;
            margin-left: -309px;
        }
        .box-fixed {
            display: inline-block;
            vertical-align: top;
            margin-right: 42px;
            width: 267px;
            background: #f7f8fa;
        }
        .answer {
            display: inline-block;
            width: 75%;
            overflow-y: auto;
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                span {
                    color: #2961EF;
                }
            }
            .timubox {
                border-bottom: 7px solid #f7f8fa;
                margin-top: 22px;
                padding-bottom: 40px;
                &:last-child {
                    border-bottom: none;
                }
                .timu {
                    font-size: 18px;
                    color: #333333;
                }
                .list {
                    height: 50px;
                    line-height: 50px;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #e1e1e1;
                    margin-top: 22px;
                    font-size: 16px;
                    color: #888888;
                    span {
                        display: inline-block;
                        width: 59px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        background: #cdcdcd;
                        border-radius: 5px 5px 5px 5px;
                        border: 1px solid #e1e1e1;
                        font-size: 22px;
                        color: #ffffff;
                        margin-right: 17px;
                    }
                    .spanactive {
                        background: #2961EF;
                    }
                }
                .listactive {
                    border: 1px solid #2961EF;
                    color: #2961EF;
                }
                // 答案
                .answer {
                    background: #fffbf7;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #fde7b5;
                    padding: 15px 11px 37px 26px;
                    margin-top: 23px;
                    width: 95.5%;
                    .top {
                        font-size: 16px;
                        color: #2961EF;
                        margin-bottom: 9px;
                    }
                    .bottom {
                        span {
                            color: #2961EF;
                        }
                        font-size: 16px;
                        line-height: 30px;
                        color: #888888;
                    }
                }
            }
            .quest {
                font-size: 18px;
                color: #333333;
                border-bottom: 7px solid #f7f8fa;
                margin-top: 16px;
                padding-bottom: 30px;
                margin-bottom: 40px;
                textarea {
                    width: 95%;
                    height: 130px;
                    background: #f7f8fa;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #e1e1e1;
                    padding: 11px 19px;
                    margin-top: 19px;
                    &::placeholder {
                        font-size: 16px;
                        color: #999999;
                    }
                }
                // 答案
                .answerlist {
                    background: #fffbf7;
                    border-radius: 5px 5px 5px 5px;
                    border: 1px solid #fde7b5;
                    padding: 15px 11px 37px 26px;
                    margin-top: 23px;
                    width: 95.5%;
                    .bottom {
                        margin-top: 20px;
                        span {
                            color: #2961EF;
                        }
                        font-size: 16px;
                        line-height: 30px;
                        color: #888888;
                    }
                }
            }
    
            .submit {
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                img {
                    width: 22px;
                    height: 26px;
                    margin: 0 14px 0 42px;
                }
                width: 185px;
                height: 51px;
                line-height: 51px;
                background: #2961EF;
                border-radius: 32px 32px 32px 32px;
                font-size: 16px;
                color: #ffffff;
                float: right;
            }
        }
    }
    
</style>